import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const mineVuex = createNamespacedHelpers("mine");
const assetsVuex = createNamespacedHelpers("assets");
import formatter from "@utils/formatter";
export default {
  name: "giftsHead",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "taskCount", "setting"]),
    ...userVuex.mapState(["userData"]),
    ...assetsVuex.mapState(["assetsList"]),
    route() {
      return this.$route.path;
    },
    avatarUrl() {
      return "https://static.tapcoins.app/avatar";
    },
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      popMenuShow: false,
      balance: {
        usdt: {
          balance: 0,
          icon: null
        },
        Stars: {
          balance: 0,
          icon: null
        },
        ton: {
          balance: null,
          icon: null
        },
        tap: {
          balance: 0,
          icon: null
        },
        stock: {
          balance: 0,
          icon: require("@images/tapcoin/new/TAPSTOCK-small.png")
        },
        coin: {
          balance: 0,
          icon: require("@images/tapcoin/new/TAPCOINS-small.png")
        }
      }
    };
  },
  methods: {
    ...assetsVuex.mapActions(["getAssetsChains", "getAssetsList"]),
    onSkip(path, id) {
      if (path == "squad") {
        this.$router.push(`/${path}?id=${id}`);
        return;
      }
      this.$router.push(`/${path}`);
    },
    formatList() {
      console.log("this.assetsList", this.assetsList);
      this.assetsList.map(item => {
        for (const key in this.balance) {
          if (item.name == key) {
            this.balance[key].balance = item.balance;
            this.balance[key].icon = item.icon;
          }
        }
      });
      this.balance["stock"].balance = this.userData.stock;
      this.balance["coin"].balance = this.userData.coin;
    },
    async refreshFnc() {
      await this.getAssetsList();
      this.formatList();
    }
  },
  async mounted() {
    this.refreshFnc();
  }
};